var map = {
	"./add-assignment-icon.svg": 199,
	"./add-clinician-icon.svg": 1194,
	"./add-patient-icon.svg": 2339,
	"./backward-3-seconds.svg": 7932,
	"./bg-intro-org.svg": 679,
	"./building-line.svg": 6814,
	"./building.svg": 1089,
	"./clinician-icon.svg": 4900,
	"./clinician-outline-icon.svg": 7980,
	"./clinicians-empty.svg": 3206,
	"./clinicians-icon.svg": 282,
	"./dragging-icon.svg": 2736,
	"./eye-icon.svg": 939,
	"./forward-3-seconds.svg": 8481,
	"./invalid-icon.svg": 386,
	"./logo.svg": 148,
	"./org-select.svg": 1125,
	"./patients-icon-outline.svg": 4787,
	"./patients-icon.svg": 4558,
	"./pause-icon.svg": 6510,
	"./pause.svg": 9648,
	"./play-icon.svg": 8872,
	"./play.svg": 185,
	"./prompt-empty.svg": 671,
	"./recordings-empty.svg": 1446,
	"./search-normal.svg": 5501,
	"./sent-invite-icon.svg": 5488,
	"./star-icon.svg": 9958,
	"./success-icon.svg": 7464,
	"./union-horizontal.svg": 6163,
	"./union-vertical.svg": 5235,
	"./user-setting.svg": 2869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1034;